import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Async from 'components/Async';
import EmptyData from 'components/EmptyData';
import Page from 'components/Page';
import store from 'store';

// import ConsultationPackagesEnum from '@common/constants/Consultations';

import ProgramItem from './ProgramItem';
import CurrentLearningFlow from './CurrentLearningFlow';
import { ProgramsSectionWrap } from './styled';

function ProgramsPage() {
	const { t } = useTranslation();
	const isCreditsTisStudent = store.profile?.isCreditsTisStudentView;

	// useEffect(() => {
	// 	if (
	// 		!store.profile?.consultation?.opened_consultation_link &&
	// 		store.profile?.consultation?.package_id === ConsultationPackagesEnum.SELF_PACED
	// 	) {
	// 		store.profile?.consultation?.updateConsultationUserAction();
	// 	}
	// }, [store.profile]);

	return (
		<Page title={isCreditsTisStudent ? <CurrentLearningFlow programs={store.allPrograms} /> : t('programs.main')} type="list">
			<Async loading={store.studentProgramsLoading || store.indivStudentProgramsLoading}>
				{store.allPrograms.length <= 0 ? (
					<EmptyData subTitle={t('shared.emptyDataSubTitle')} />
				) : (
					<ProgramsSectionWrap>
						{store.allPrograms.map((program, key) => (
							<ProgramItem programModel={program} key={key} />
						))}
					</ProgramsSectionWrap>
				)}
			</Async>
		</Page>
	);
}

export default observer(ProgramsPage);
